import React from 'react';
import Skeleton from './Skeleton';
import SkeletonTablet from './SkeletonTablet';

const SkeletonPage = ({ device }) => {
  return (
    <>
      {device === 'desktop' ? (
        <>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </>
      ) : (
        <>
          <SkeletonTablet />
          <SkeletonTablet />
          <SkeletonTablet />
        </>
      )}
    </>
  );
};

export default React.memo(SkeletonPage);
